import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import InstallPromptTrigger from '@alltrails/amplitude/enums/InstallPromptTrigger';
import type Experiments from '@alltrails/types/Experiments';

/* 
  Provides commonly used params for install event analytics.
*/

type Config = {
  experiments: Experiments;
  displayTrigger?: CarouselDisplayTrigger | InstallPromptTrigger;
  promptType?: string;
  browserName?: string;
};

const getAnalyticsParams = ({ promptType, browserName, displayTrigger, experiments }: Config) => {
  const params = new URLSearchParams();

  params.append('type', 'install_prompt');

  // Non-exhaustive list of experiments that should be included in the analytics events.
  const experimentKeys: Array<keyof Experiments> = ['web-growth-rm-unauth-tdp-open-in-app-map'];

  experimentKeys.forEach(key => {
    const value = experiments[key]?.value;

    if (value) {
      params.append(key, value);
    }
  });

  if (promptType) {
    params.append('feature', `native_${promptType}`);
  }

  if (browserName) {
    params.append('browser', browserName);
  }

  if (displayTrigger) {
    params.append('creative_name', displayTrigger);
  }

  return params;
};

export default getAnalyticsParams;
